import React from "react";
import { Paper, Typography, Box, Grid } from "@mui/material";
import { ExpenseReportData } from "../types";
import ReportPie from "./ReportPie";
import { formatCurrency } from "../../../utils/utils";

interface ExpenseSummaryProps {
  data: ExpenseReportData;
}

const ExpenseSummary: React.FC<ExpenseSummaryProps> = ({ data }) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Paper
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          py: 1.5,
          gap: 2,
        }}
      >
        <Typography fontSize={12}>Total Expenses</Typography>
        <Typography variant="h4" fontSize={14}>
          {formatCurrency(parseFloat(data.summary.total_expenses))}{" "}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          py: 1.5,
          gap: 2,
        }}
      >
        <Typography fontSize={12}>Total Paid</Typography>
        <Typography variant="h4" fontSize={14}>
          {formatCurrency(parseFloat(data.summary.total_payments))}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          py: 1.5,
          gap: 2,
        }}
      >
        <Typography fontSize={12}>Balance</Typography>
        <Typography variant="h4" fontSize={14}>
          {formatCurrency(parseFloat(data.summary.outstanding_amount))}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          py: 1.5,
          gap: 2,
        }}
      >
        <Typography fontSize={12}>Total Records</Typography>
        <Typography variant="h4" fontSize={14}>
          {data.summary.total_expense_count}
        </Typography>
      </Paper>
      {/* <Paper
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          py: 1.5,
          gap: 2,
        }}
      >
        <Typography fontSize={12}>Vehicles & Types</Typography>
        <Typography variant="h4" fontSize={14}>
          {data.summary.total_vehicles} vehicles, {data.summary.total_expense_types} types
        </Typography>
      </Paper> */}
    </Box>
  );
};

export default ExpenseSummary;
